// src/App.js
import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider } from './AuthContext';
import PrivateRoute from './PrivateRoute';
import Home from './Home';
import Login from './Login';
import Signup from './Signup';
import PricingInfo from './PricingInfo';
import { MsalProvider, useMsal } from "@azure/msal-react";
import { msalInstance } from './msalConfig';
import './App.css';

function MsalRedirectHandler() {
  const { instance } = useMsal();
  React.useEffect(() => {
    instance.handleRedirectPromise().catch(console.error);
  }, [instance]);
  // once MSAL has processed the response, send them home:
  return <Navigate to="/" replace />;
}

function App() {
  return (
    <Router>
      <MsalProvider instance={msalInstance}>
        <AuthProvider>
          <Routes>
            <Route
              path="/"
              element={
                <PrivateRoute>
                  <Home />
                </PrivateRoute>
              }
            />
            <Route path="/auth-callback" element={<MsalRedirectHandler />} />
            <Route path="/login" element={<Login />} />
            <Route path="/signup" element={<Signup />} />
            <Route path="/pricing" element={<PricingInfo />} />
          </Routes>
        </AuthProvider>
      </MsalProvider>
    </Router>
  );
}

export default App;
